import styled from "styled-components";
import ManualOrder from "../Components/ManualOrder/NewOrder/NewManualOrder";
import { useParams } from 'react-router-dom';
const Container = styled.div`
  width: 100%;
  height: 95vh;
  /* display: flex; */
  border: 1px solid lightgray;
  display: flex;
  justify-content: center;
  align-items: center;
`;

//NOTE:- The is manualOrder component . From this component , we can save a manual Order, with the following information like
//Center name , modality ,bodypart, name , appointment date time etc....
const ManualOrderContainer = () => {
    const params = useParams();
    // console.log("params:",params?.conversation_id)
    let conversation_id = null;
    if (params?.conversation_id) {
        conversation_id = params?.conversation_id
    }
    return (
        <Container>
            {conversation_id === null && <ManualOrder />}
            {conversation_id != null && <ManualOrder conversation_id={params?.conversation_id} />}
        </Container>
    );
};

export default ManualOrderContainer;
